import Immutable from 'immutable';
import { deepMerge } from 'nike-ui/src/common/immutable/merge';

function prepare(json) {
    // const boxId = data.boxes.find(box => box.selectedBetsHierarchy && Object.keys(box.selectedBetsHierarchy).length).boxId;
    const box = json.boxes.find(ibox => !ibox.special);
    const sportEvent = (json.sportEvents || [])[0];
    const markets = (json.markets || []).reduce((acc, market) => {
        acc[market.marketId] = market;
        return acc;
    }, {});
    const bets = (json.bets || []).reduce((acc, bet) => {
        acc[bet.betId] = bet;
        return acc;
    }, {});
    return Immutable.fromJS({ box, markets, bets, sportEvent });
}

export function mergeUpdater(json) {
    return existing => deepMerge(existing, prepare(json));
}

export function setUpdater(json) {
    return () => prepare(json);
}
